webpackJsonp([57],{

/***/ 1192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_filters__ = __webpack_require__(278);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function fullName() {
	return this.lastname + ' ' + this.name;
}

function image() {
	var icon = '';
	if (this.bookingState === 2) {
		icon = 'checkin';
	} else if (this.bookingState === 3) {
		icon = 'checkout';
	} else if (this.bookingState === 6) {
		icon = 'no-show';
	} else if (this.bookingState === 7) {
		icon = 'in-house';
	}
	return icon;
}

function reservationState() {
	return this.bookingState === 1;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'housekeeping-card',
	computed: {
		fullName: fullName,
		image: image,
		reservationState: reservationState
	},
	filters: {
		parseDate: __WEBPACK_IMPORTED_MODULE_0__shared_filters__["b" /* parseDate */],
		round: __WEBPACK_IMPORTED_MODULE_0__shared_filters__["c" /* round */],
		truncate: __WEBPACK_IMPORTED_MODULE_0__shared_filters__["d" /* truncate */]
	},
	props: {
		flagObserved: {
			type: Boolean,
			required: true,
			default: null
		},
		roomNumber: {
			type: Number,
			required: true,
			default: null
		},
		roomTypeCode: {
			type: String,
			required: true,
			default: ''
		},
		lastname: {
			type: String,
			required: true,
			default: ''
		},
		name: {
			type: String,
			required: true,
			default: ''
		},
		startDate: {
			type: String,
			required: true,
			default: ''
		},
		endDate: {
			type: String,
			required: true,
			default: ''
		},
		currency: {
			type: String,
			required: true,
			default: ''
		},
		bookingTotal: {
			type: [Number, String],
			required: true,
			default: 0
		},
		bookingColor: {
			type: String,
			required: true,
			default: 'transparent'
		},
		bookingState: {
			default: 1,
			type: Number
		},
		href: {
			default: '/dashboard',
			type: [String, Object]
		}
	}
});

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".text-observed[data-v-3c03f2f0]{color:#ffe955;font-family:San Francisco Display;font-size:12px;position:relative;right:10px;top:7px}.housekeeping-card[data-v-3c03f2f0]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-shadow:0 4px 9px 0 rgba(0,0,0,.13);box-shadow:0 4px 9px 0 rgba(0,0,0,.13);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:102px;margin-bottom:19px;margin-left:15px;min-width:179px;position:relative;width:179px}.housekeeping-card .details[data-v-3c03f2f0]{left:0;position:absolute;right:0;top:0}.housekeeping-card .details img[data-v-3c03f2f0]{right:0}.housekeeping-card .info-details[data-v-3c03f2f0]{position:relative;width:100%}.housekeeping-card .state[data-v-3c03f2f0]{height:auto;min-width:auto;padding:5px;position:absolute;right:0;width:auto}.housekeeping-card .room[data-v-3c03f2f0]{color:#f4f4f4;font-family:San Francisco Display Medium;height:16px;left:7px;position:absolute}.housekeeping-card .room .dsq[data-v-3c03f2f0]{display:block;font-size:10px;height:12px;margin-top:-5px;width:19px}.housekeeping-card .room img[data-v-3c03f2f0]{right:0}.housekeeping-card .triangle-left[data-v-3c03f2f0]{border-bottom:30px solid transparent;border-right:30px solid transparent;height:0;width:0}.housekeeping-card .name[data-v-3c03f2f0]{color:#545e72;font-family:San Francisco Display Semi Bold;font-size:12px;height:28px;letter-spacing:normal;line-height:normal;max-width:100px;margin:auto;text-align:center}.housekeeping-card .date[data-v-3c03f2f0],.housekeeping-card .price[data-v-3c03f2f0]{color:#828282;height:14px;font-size:12px;font-stretch:normal;font-style:normal;font-weight:400;letter-spacing:normal;line-height:normal;text-align:left;width:67px}.housekeeping-card .divider[data-v-3c03f2f0]{background:transparent;border-top:1px dashed #dadada;bottom:-13px;left:3px;position:absolute;right:0}.bar-caption-icon.booking[data-v-3c03f2f0]{background-color:#0fcde2;border-radius:50%;color:#fff;display:inline-block;height:14px;line-height:14px;text-align:center;width:14px}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/HousekeepingCard.vue"],"names":[],"mappings":"AACA,gCACE,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,kBAAmB,AACnB,WAAY,AACZ,OAAS,CACV,AACD,oCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,+CAAoD,AAC5C,uCAA4C,AACpD,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AACpB,iBAAkB,AAClB,gBAAiB,AACjB,kBAAmB,AACnB,WAAa,CACd,AACD,6CACI,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,KAAO,CACV,AACD,iDACM,OAAS,CACd,AACD,kDACI,kBAAmB,AACnB,UAAY,CACf,AACD,2CACI,YAAa,AACb,eAAgB,AAChB,YAAa,AACb,kBAAmB,AACnB,QAAS,AACT,UAAY,CACf,AACD,0CACI,cAAe,AACf,yCAA4C,AAC5C,YAAa,AACb,SAAU,AACV,iBAAmB,CACtB,AACD,+CACM,cAAe,AACf,eAAgB,AAChB,YAAa,AACb,gBAAiB,AACjB,UAAY,CACjB,AACD,8CACM,OAAS,CACd,AACD,mDACI,qCAAsC,AACtC,oCAAqC,AACrC,SAAU,AACV,OAAS,CACZ,AACD,0CACI,cAAe,AACf,4CAA+C,AAC/C,eAAgB,AAChB,YAAa,AACb,sBAAuB,AACvB,mBAAoB,AACpB,gBAAiB,AACjB,YAAa,AACb,iBAAmB,CACtB,AACD,qFACI,cAAe,AACf,YAAa,AACb,eAAgB,AAChB,oBAAqB,AACrB,kBAAmB,AACnB,gBAAoB,AACpB,sBAAuB,AACvB,mBAAoB,AACpB,gBAAiB,AACjB,UAAY,CACf,AACD,6CACI,uBAAwB,AACxB,8BAA+B,AAC/B,aAAc,AACd,SAAU,AACV,kBAAmB,AACnB,OAAS,CACZ,AACD,2CACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,qBAAsB,AACtB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,UAAY,CACb","file":"HousekeepingCard.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.text-observed[data-v-3c03f2f0] {\n  color: #ffe955;\n  font-family: \"San Francisco Display\";\n  font-size: 12px;\n  position: relative;\n  right: 10px;\n  top: 7px;\n}\n.housekeeping-card[data-v-3c03f2f0] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.13);\n          box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.13);\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  height: 102px;\n  margin-bottom: 19px;\n  margin-left: 15px;\n  min-width: 179px;\n  position: relative;\n  width: 179px;\n}\n.housekeeping-card .details[data-v-3c03f2f0] {\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n.housekeeping-card .details img[data-v-3c03f2f0] {\n      right: 0;\n}\n.housekeeping-card .info-details[data-v-3c03f2f0] {\n    position: relative;\n    width: 100%;\n}\n.housekeeping-card .state[data-v-3c03f2f0] {\n    height: auto;\n    min-width: auto;\n    padding: 5px;\n    position: absolute;\n    right: 0;\n    width: auto;\n}\n.housekeeping-card .room[data-v-3c03f2f0] {\n    color: #f4f4f4;\n    font-family: \"San Francisco Display Medium\";\n    height: 16px;\n    left: 7px;\n    position: absolute;\n}\n.housekeeping-card .room .dsq[data-v-3c03f2f0] {\n      display: block;\n      font-size: 10px;\n      height: 12px;\n      margin-top: -5px;\n      width: 19px;\n}\n.housekeeping-card .room img[data-v-3c03f2f0] {\n      right: 0;\n}\n.housekeeping-card .triangle-left[data-v-3c03f2f0] {\n    border-bottom: 30px solid transparent;\n    border-right: 30px solid transparent;\n    height: 0;\n    width: 0;\n}\n.housekeeping-card .name[data-v-3c03f2f0] {\n    color: #545e72;\n    font-family: \"San Francisco Display Semi Bold\";\n    font-size: 12px;\n    height: 28px;\n    letter-spacing: normal;\n    line-height: normal;\n    max-width: 100px;\n    margin: auto;\n    text-align: center;\n}\n.housekeeping-card .date[data-v-3c03f2f0], .housekeeping-card .price[data-v-3c03f2f0] {\n    color: #828282;\n    height: 14px;\n    font-size: 12px;\n    font-stretch: normal;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    line-height: normal;\n    text-align: left;\n    width: 67px;\n}\n.housekeeping-card .divider[data-v-3c03f2f0] {\n    background: transparent;\n    border-top: 1px dashed #dadada;\n    bottom: -13px;\n    left: 3px;\n    position: absolute;\n    right: 0;\n}\n.bar-caption-icon.booking[data-v-3c03f2f0] {\n  background-color: #0fcde2;\n  border-radius: 50%;\n  color: #ffffff;\n  display: inline-block;\n  height: 14px;\n  line-height: 14px;\n  text-align: center;\n  width: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1207:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1199);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("6b77eb6c", content, true);

/***/ }),

/***/ 1213:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1207)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1192),
  /* template */
  __webpack_require__(1221),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c03f2f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1221:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "housekeeping-card"
  }, [_c('div', {
    staticClass: "details"
  }, [(!_vm.reservationState) ? _c('v-btn', {
    staticClass: "state",
    attrs: {
      "to": _vm.href,
      "icon": ""
    }
  }, [(_vm.flagObserved) ? _c('p', {
    staticClass: "text-observed"
  }, [_vm._v("Observado")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/" + _vm.image + "-icon.svg")
    }
  })]) : _c('v-btn', {
    staticClass: "state",
    attrs: {
      "to": _vm.href,
      "icon": ""
    }
  }, [(_vm.flagObserved) ? _c('p', {
    staticClass: "text-observed"
  }, [_vm._v("Observado")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "bar-caption-icon booking"
  }, [_vm._v("\n\t\t\t\t\tR\n\t\t\t\t")])]), _vm._v(" "), _c('router-link', {
    staticClass: "room",
    attrs: {
      "to": _vm.href
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.roomNumber) + "\n\t\t\t\t"), _c('span', {
    staticClass: "dsq"
  }, [_vm._v(_vm._s(_vm.roomTypeCode))])]), _vm._v(" "), _c('div', {
    staticClass: "triangle-left",
    style: (("border-left: 30px solid " + _vm.bookingColor + "; border-top: 30px solid " + _vm.bookingColor + ";"))
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-details"
  }, [_c('p', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: _vm.fullName
      }),
      expression: "{ html: fullName }",
      arg: "left"
    }],
    staticClass: "name",
    attrs: {
      "text-xs-center": ""
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("truncate")(_vm.fullName)) + "\n\t\t\t")]), _vm._v(" "), _c('v-layout', {
    staticClass: "divider",
    attrs: {
      "justify": ""
    }
  }, [_c('v-flex', {
    staticClass: "date",
    attrs: {
      "md6": "",
      "text-xs-left": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.startDate, 'DD/MM')) + " - " + _vm._s(_vm._f("parseDate")(_vm.endDate, 'DD/MM')))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "price",
    attrs: {
      "md6": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currency) + " " + _vm._s(_vm._f("round")(_vm.bookingTotal)))])])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HousekeepingCard__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HousekeepingCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HousekeepingCard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function data() {
	return {
		customStates: [{
			id: 1,
			image: '',
			name: 'no show'
		}, {
			id: 2,
			image: '',
			name: 'Check in'
		}, {
			id: 3,
			image: '',
			name: 'Check out'
		}],
		bookings: [{
			id: 1,
			roomNumber: 103,
			roomTypeCode: 'DSQ',
			roomState: 4,
			bookingState: 1,
			color: '#f5d623',
			client: {
				lastname: 'Dávila Guerrero',
				name: 'Jorge'
			},
			currency: 'USD',
			startDate: '21/05',
			endDate: '01/06',
			bookingTotal: 942.23,
			image: '/static/img/icon.png'
		}, {
			id: 2,
			roomNumber: 103,
			roomTypeCode: 'DSQ',
			roomState: 4,
			bookingState: 1,
			color: '#ff0053',
			client: {
				lastname: 'Dávila Guerrero',
				name: 'Jorge'
			},
			currency: 'USD',
			startDate: '21/05',
			endDate: '01/06',
			bookingTotal: 942.23,
			image: '/static/img/icon.png'
		}, {
			id: 3,
			roomNumber: 103,
			roomTypeCode: 'DSQ',
			roomState: 4,
			bookingState: 1,
			color: '#f6a623',
			client: {
				lastname: 'Dávila Guerrero',
				name: 'Jorge'
			},
			currency: 'USD',
			startDate: '21/05',
			endDate: '01/06',
			bookingTotal: 942.23,
			image: '/static/img/icon.png'
		}, {
			id: 4,
			roomNumber: 103,
			roomTypeCode: 'DSQ',
			roomState: 4,
			bookingState: 1,
			color: '#f5d623',
			client: {
				lastname: 'Dávila Guerrero',
				name: 'Jorge'
			},
			currency: 'USD',
			startDate: '21/05',
			endDate: '01/06',
			bookingTotal: 942.23,
			image: '/static/img/icon.png'
		}, {
			id: 5,
			roomNumber: 103,
			roomTypeCode: 'DSQ',
			roomState: 4,
			bookingState: 1,
			color: '#0fe270',
			client: {
				lastname: 'Dávila Guerrero',
				name: 'Jorge'
			},
			currency: 'USD',
			startDate: '21/05',
			endDate: '01/06',
			bookingTotal: 942.23,
			image: '/static/img/icon.png'
		}, {
			id: 6,
			roomNumber: 103,
			roomTypeCode: 'DSQ',
			roomState: 4,
			bookingState: 1,
			color: '#97a6c2',
			client: {
				lastname: 'Dávila Guerrero',
				name: 'Jorge'
			},
			currency: 'USD',
			startDate: '21/05',
			endDate: '01/06',
			bookingTotal: 942.23,
			image: '/static/img/icon.png'
		}, {
			id: 6,
			roomNumber: 103,
			roomTypeCode: 'DSQ',
			roomState: 4,
			bookingState: 1,
			color: '#0fcde2',
			client: {
				lastname: 'Dávila Guerrero',
				name: 'Jorge'
			},
			currency: 'USD',
			startDate: '21/05',
			endDate: '01/06',
			bookingTotal: 942.23,
			image: '/static/img/icon.png'
		}]
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'list',
	data: data,
	components: {
		housekeepingCard: __WEBPACK_IMPORTED_MODULE_0__components_shared_HousekeepingCard___default.a
	}
});

/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".housekeeping[data-v-79cb7982]{background-color:#fff;margin:0;padding:18px 10px;text-align:left;width:100%}.housekeeping .state-room[data-v-79cb7982]{font-size:14px}.housekeeping .state-room .check-inn[data-v-79cb7982],.housekeeping .state-room .checkout[data-v-79cb7982],.housekeeping .state-room .no-show[data-v-79cb7982]{color:#818181;padding:5px;font-weight:400;font-style:normal;font-stretch:normal;letter-spacing:normal;line-height:normal}.housekeeping .search[data-v-79cb7982]{border:1px solid;border-radius:9px;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:12px;height:34.3px;left:0;padding:0!important;right:0;width:274.8px}.housekeeping .search .btn--icon .btn__content[data-v-79cb7982]{height:14px;width:14px}.housekeeping .search input[data-v-79cb7982]{color:#545e72;font-size:13px;font-weight:400;font-style:normal;font-stretch:normal;height:34px;line-height:normal;letter-spacing:normal;margin:0 -2px;padding:0 8px;text-align:left;width:100%}.housekeeping .icon[data-v-79cb7982]{border-radius:2px;height:8px;width:8px}.housekeeping .icon.maintenance[data-v-79cb7982]{background-color:#97a6c3}.housekeeping .icon.clean-bussy[data-v-79cb7982]{background-color:#0fcde2}.housekeeping .icon.unclean-bussy[data-v-79cb7982]{background-color:#ff0053}.housekeeping .icon.clean-empty[data-v-79cb7982]{background-color:#0fe270}.housekeeping .icon.unclean-empty[data-v-79cb7982]{background-color:#f5a623}.housekeeping .state-room span[data-v-79cb7982]{color:#818181;font-weight:400;font-style:normal;font-stretch:normal;letter-spacing:normal;line-height:normal}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/housekeeping/List.vue"],"names":[],"mappings":"AACA,+BACE,sBAAuB,AACvB,SAAY,AACZ,kBAAmB,AACnB,gBAAiB,AACjB,UAAY,CACb,AACD,2CACI,cAAgB,CACnB,AACD,+JACM,cAAe,AACf,YAAa,AACb,gBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,sBAAuB,AACvB,kBAAoB,CACzB,AACD,uCACI,iBAAkB,AAClB,kBAAmB,AACnB,8CAAmD,AAC3C,sCAA2C,AACnD,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,eAAgB,AAChB,cAAe,AACf,OAAQ,AACR,oBAA4B,AAC5B,QAAS,AACT,aAAe,CAClB,AACD,gEACM,YAAa,AACb,UAAY,CACjB,AACD,6CACM,cAAe,AACf,eAAgB,AAChB,gBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,YAAa,AACb,mBAAoB,AACpB,sBAAuB,AACvB,cAAe,AACf,cAAiB,AACjB,gBAAiB,AACjB,UAAY,CACjB,AACD,qCACI,kBAAmB,AACnB,WAAY,AACZ,SAAW,CACd,AACD,iDACM,wBAA0B,CAC/B,AACD,iDACM,wBAA0B,CAC/B,AACD,mDACM,wBAA0B,CAC/B,AACD,iDACM,wBAA0B,CAC/B,AACD,mDACM,wBAA0B,CAC/B,AACD,gDACI,cAAe,AACf,gBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,sBAAuB,AACvB,kBAAoB,CACvB","file":"List.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.housekeeping[data-v-79cb7982] {\n  background-color: #fff;\n  margin: 0px;\n  padding: 18px 10px;\n  text-align: left;\n  width: 100%;\n}\n.housekeeping .state-room[data-v-79cb7982] {\n    font-size: 14px;\n}\n.housekeeping .state-room .no-show[data-v-79cb7982], .housekeeping .state-room .check-inn[data-v-79cb7982], .housekeeping .state-room .checkout[data-v-79cb7982] {\n      color: #818181;\n      padding: 5px;\n      font-weight: normal;\n      font-style: normal;\n      font-stretch: normal;\n      letter-spacing: normal;\n      line-height: normal;\n}\n.housekeeping .search[data-v-79cb7982] {\n    border: solid 1px;\n    border-radius: 9px;\n    -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    font-size: 12px;\n    height: 34.3px;\n    left: 0;\n    padding: 0px 0px !important;\n    right: 0;\n    width: 274.8px;\n}\n.housekeeping .search .btn--icon .btn__content[data-v-79cb7982] {\n      height: 14px;\n      width: 14px;\n}\n.housekeeping .search input[data-v-79cb7982] {\n      color: #545e72;\n      font-size: 13px;\n      font-weight: normal;\n      font-style: normal;\n      font-stretch: normal;\n      height: 34px;\n      line-height: normal;\n      letter-spacing: normal;\n      margin: 0 -2px;\n      padding: 0px 8px;\n      text-align: left;\n      width: 100%;\n}\n.housekeeping .icon[data-v-79cb7982] {\n    border-radius: 2px;\n    height: 8px;\n    width: 8px;\n}\n.housekeeping .icon.maintenance[data-v-79cb7982] {\n      background-color: #97a6c3;\n}\n.housekeeping .icon.clean-bussy[data-v-79cb7982] {\n      background-color: #0fcde2;\n}\n.housekeeping .icon.unclean-bussy[data-v-79cb7982] {\n      background-color: #ff0053;\n}\n.housekeeping .icon.clean-empty[data-v-79cb7982] {\n      background-color: #0fe270;\n}\n.housekeeping .icon.unclean-empty[data-v-79cb7982] {\n      background-color: #f5a623;\n}\n.housekeeping .state-room span[data-v-79cb7982] {\n    color: #818181;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    line-height: normal;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("1e65f7c7", content, true);

/***/ }),

/***/ 1676:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "housekeeping"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": "",
      "text-xs-left": "",
      "pl-3": ""
    }
  }, [_c('p', [_vm._v("Estados de habitaciones:")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "search",
    attrs: {
      "md2": "",
      "text-xs-right": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Buscar huésped, habitaciones…"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "state-room",
    attrs: {
      "text-xs-left": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "no-show",
    attrs: {
      "md3": "",
      "id": "1"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("No Show")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "check-inn",
    attrs: {
      "md3": "",
      "id": "2"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("Check in")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "checkout",
    attrs: {
      "id": "3"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("Check Out")])])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    staticClass: "state-room",
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "icon maintenance"
  }), _vm._v(" "), _c('span', [_vm._v("Mantenimiento")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "icon clean-bussy"
  }), _vm._v(" "), _c('span', [_vm._v("Ocupado limpio")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "icon unclean-bussy"
  }), _vm._v(" "), _c('span', [_vm._v("Ocupado sucio")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "icon clean-empty"
  }), _vm._v(" "), _c('span', [_vm._v("Vacías limpias")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "icon unclean-empty"
  }), _vm._v(" "), _c('span', [_vm._v("Vacías sucias")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "pt-4": ""
    }
  }, _vm._l((_vm.bookings), function(booking) {
    return _c('housekeeping-card', {
      key: booking.id,
      attrs: {
        "image": booking.image,
        "roomNumber": booking.roomNumber,
        "roomTypeCode": booking.roomTypeCode,
        "lastname": booking.client.lastname,
        "name": booking.client.name,
        "startDate": booking.startDate,
        "endDate": booking.endDate,
        "currency": booking.currency,
        "bookingTotal": booking.bookingTotal,
        "bookingColor": booking.color
      }
    })
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1513)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1288),
  /* template */
  __webpack_require__(1676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79cb7982",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/57.b1a182a1ffda3a3e57a4.js